/*global _ */
export default {
  methods: {
    updateDesignerTitle: _.debounce(function (e) {
      const {component} = this.designerObject || {}
      const title = e.target.innerHTML
      this.$set(this.designerObject, 'title', title)
      const vueOptions = component.get('vueOptions') || {}
      _.set(vueOptions, 'props.designerTranslations.title', title)
      component.set('vueOptions', null)
      component.set('vueOptions', vueOptions)
    }, 200, {leading: false, trailing: true})
  }
}
